import { globalObject } from '@skbkontur/global-object';
import { isIE11 } from "../client";

var needsPolyfillPlaceholderInternal = function needsPolyfillPlaceholderInternal() {
  if (globalObject.document) {
    var supportsPlaceholder = ('placeholder' in globalObject.document.createElement('input'));

    if (!supportsPlaceholder || isIE11) {
      return true;
    }
  }

  return false;
};
/**
 * Определяет поддерживает ли браузер аттрибут `placeholder` для тега `input`
 *
 * Равен true, если браузеру нужен полифил для placeholder. Иначе - false
 */


export var needsPolyfillPlaceholder = needsPolyfillPlaceholderInternal();